var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper page-not-found"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }